(() => {
  'use strict';
  if (window.AWReplicaPurchaseContextP2?.version) return;

  const VERSION = '1.0.2';
  const KEY = 'aw_replica_purchase_context_v1';
  const REPLICAS_KEY = 'aw_garage_replicas_v1';
  const TTL_MS = 30 * 60 * 1000;

  const clean = (value = '') => String(value || '').trim();
  const readJson = (storage, key, fallback) => {
    try { return JSON.parse(storage.getItem(key) || 'null') ?? fallback; }
    catch (_) { return fallback; }
  };
  const replicas = () => {
    const value = readJson(localStorage, REPLICAS_KEY, []);
    return Array.isArray(value) ? value : [];
  };
  const replicaById = (id) => replicas().find((item) => clean(item?.id) === clean(id)) || null;
  const pathOnly = (value = '') => {
    try { return new URL(value, location.origin).pathname.replace(/\/+$/, '') || '/'; }
    catch (_) { return ''; }
  };
  const clear = () => {
    try { sessionStorage.removeItem(KEY); } catch (_) {}
  };

  const read = () => {
    const ctx = readJson(sessionStorage, KEY, null);
    if (!ctx || Number(ctx.expiresAt || 0) <= Date.now()) {
      clear();
      return null;
    }
    if (!ctx.replicaId || !replicaById(ctx.replicaId)) {
      clear();
      return null;
    }
    const currentPath = pathOnly(location.href);
    if (!currentPath || pathOnly(ctx.pathname) !== currentPath) {
      clear();
      return null;
    }
    return ctx;
  };

  const remember = (link) => {
    const pack = link?.closest?.('[data-aw-owned-pack-replica]');
    const item = link?.closest?.('[data-aw-owned-pack-product]');
    const replicaId = clean(pack?.dataset?.awOwnedPackReplica);
    const productId = clean(item?.dataset?.awOwnedPackProduct);
    const replica = replicaById(replicaId);
    if (!replicaId || !replica || !productId) return false;

    let url;
    try { url = new URL(link.href, location.origin); }
    catch (_) { return false; }
    if (url.origin !== location.origin || !/^\/products\/[^/]+\/?$/i.test(url.pathname)) return false;

    const now = Date.now();
    const ctx = {
      version: 1,
      replicaId,
      replicaLabel: clean(replica.nickname || replica.model || 'Réplique AW').slice(0, 120),
      productId,
      pathname: pathOnly(url.href),
      source: 'garage_owned_pack_product_link',
      createdAt: new Date(now).toISOString(),
      expiresAt: now + TTL_MS
    };
    try {
      sessionStorage.setItem(KEY, JSON.stringify(ctx));
      return true;
    } catch (_) {
      return false;
    }
  };

  const propertyInput = (form, name) => form?.elements?.namedItem?.(`properties[${name}]`) || null;
  const setHidden = (form, name, value) => {
    let input = propertyInput(form, name);
    if (input?.value) return false;
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[${name}]`;
      form.appendChild(input);
    }
    input.value = value;
    input.dataset.awReplicaPurchaseContextP2 = 'true';
    return true;
  };
  const eligibleForm = (form) => {
    if (!form?.matches?.('form')) return false;
    const action = clean(form.getAttribute('action') || form.action);
    return /\/cart\/add(?:\.js)?(?:[?#]|$)/i.test(action);
  };

  const decorate = (form) => {
    if (!eligibleForm(form)) return false;
    const ctx = read();
    if (!ctx) return false;

    const existing = propertyInput(form, '_AW Replica ID');
    if (existing?.value) {
      if (clean(existing.value) !== clean(ctx.replicaId)) clear();
      return false;
    }

    const replica = replicaById(ctx.replicaId);
    if (!replica) {
      clear();
      return false;
    }

    const changed = setHidden(form, '_AW Replica ID', clean(ctx.replicaId).slice(0, 120));
    setHidden(form, '_AW Replica Label', clean(replica.nickname || replica.model || ctx.replicaLabel || 'Réplique AW').slice(0, 120));
    setHidden(form, '_AW Purchase Context', 'garage_owned_pack_product_link');
    form.dataset.awReplicaPurchaseContext = 'exact-explicit-garage-link';
    return changed;
  };

  const hydrate = (scope = document) => {
    const forms = [];
    if (scope?.matches?.('form[action*="/cart/add"]')) forms.push(scope);
    scope?.querySelectorAll?.('form[action*="/cart/add"]').forEach((form) => forms.push(form));
    let count = 0;
    forms.forEach((form) => { if (decorate(form)) count += 1; });
    return count;
  };

  document.addEventListener('click', (event) => {
    const link = event.target?.closest?.('[data-aw-owned-pack-link]');
    if (link) remember(link);
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target?.closest?.('form[action*="/cart/add"]');
    if (!form) return;
    const ctx = read();
    decorate(form);
    const attributed = propertyInput(form, '_AW Replica ID');
    if (ctx && clean(attributed?.value) === clean(ctx.replicaId)) clear();
  }, true);

  window.addEventListener('pageshow', () => hydrate(document));
  document.addEventListener('shopify:section:load', (event) => hydrate(event.target));

  window.AWReplicaPurchaseContextP2 = {
    version: VERSION,
    remember,
    read,
    decorate,
    hydrate,
    clear,
    policy: 'explicit-garage-pack-product-link-only;session-scoped;30-minute-expiry;exact-target-path;existing-garage-replica-required;never-infer-from-active-replica-alone;never-overwrite-existing-replica-id'
  };

  const start = () => hydrate(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();